import React, { Fragment, useState, useEffect, useLayoutEffect } from 'react';
import { Col, Tooltip } from 'reactstrap';
import { DollarSign, Sliders } from 'react-feather';
import { Link } from 'react-router-dom';

import { useGlobalState } from 'state-pool';
import { VideoAnimationToggle } from '../../components/VideoAnimationToggle';

import SweetAlert from 'sweetalert2';

const Leftbar = (props) => {
  const [web3, setWeb3] = useGlobalState('Web3');
  const [userAddress] = useGlobalState('userAddress');
  const [cryptominesContract] = useGlobalState('cryptominesContract');
  const [claimRewards, setClaimRewards] = useGlobalState('claimRewards');
  const [claimTax, setClaimTax] = useGlobalState('claimTax');
  const [stoneContract] = useGlobalState('stoneContract');
  const [stoneAmount, setStoneAmount] = useGlobalState('stoneAmount');

  const [oracleContract] = useGlobalState('oracleContract');

  const [sidebartoggle, setSidebartoggle] = useState(true);
  const width = useWindowSize();

  const [basictooltip, setbasictooltip] = useState(false);
  const toggle = () => setbasictooltip(!basictooltip);


  function useWindowSize() {
    const [size, setSize] = useState([0, 0]);
    useLayoutEffect(() => {
      function updateSize() {
        setSize(window.innerWidth);
      }
      window.addEventListener('resize', updateSize);
      updateSize();
      return () => window.removeEventListener('resize', updateSize);
    }, []);
    return size;
  }

  const claim = async () => {
    if (claimRewards == 0) {
      SweetAlert.fire({
        title: 'No rewards to claim.',
        icon: 'error',
      });
    } else {
      try {
        await cryptominesContract.methods.claimTokenRewards().send({ from: userAddress })
        .once('transactionHash', function (hash) {})
        .once('receipt', function (receipt) {})
        .on('confirmation', function (confNumber, receipt) {})
        .on('error', function (error) {})
        .then(function (receipt) {
          let reward = web3.utils.fromWei(receipt.events.eventClaimRewards.returnValues['claimedAmount'], 'ether');
            let fee = web3.utils.fromWei(receipt.events.eventClaimRewards.returnValues['claimedFee'], 'ether');
            SweetAlert.fire({
              title: 'Rewards claimed.',
              text: 'You received '+parseFloat(parseFloat(reward).toFixed(3))+" ETERNAL and "+parseFloat(parseFloat(fee).toFixed(3))+" ETERNAL was taxed for early claim.",
              icon: 'success',
            });
            window.gtag('event', 'claim', {value: reward, fee: fee});

        });
    

      



      const currentClaimRewards = await cryptominesContract.methods
        .getTokenRewards(userAddress)
        .call({ from: userAddress });

      const currentClaimTime = await cryptominesContract.methods
        .getMyTimeForClaim()
        .call({ from: userAddress });

      let now = parseInt((Date.now() / 1000).toFixed(0))
      let remainingDays = (((currentClaimTime - now) / 86400) * 2).toFixed(2)
      if(remainingDays <= 0) {
        remainingDays = 0;
      }
      if(currentClaimRewards == 0) {
        remainingDays = 30;
      }
      setClaimTax(remainingDays)

      const currentStones = await stoneContract.methods.balanceOf(userAddress).call({ from: userAddress });

      setClaimRewards(web3.utils.fromWei(currentClaimRewards, 'ether'));
      setStoneAmount(web3.utils.fromWei(currentStones, 'ether'));
    } catch (error) {
      //console.log('error: ', error);
    }
  }
  };

  useEffect(() => {

    var ignoreClick_On_Out_side_Element = document.getElementById('out_side_click');
    var ignoreClick_On_Main_Nav_Element = document.getElementById('sidebar-menu');
    document.addEventListener('click', function (event) {
      var isClickOutSideElement = ignoreClick_On_Out_side_Element.contains(event.target);
      var isClickMainNavElement = ignoreClick_On_Main_Nav_Element.contains(event.target);
      if (
        window.innerWidth <= 991 &&
        !isClickOutSideElement &&
        !isClickMainNavElement &&
        document.getElementById('sidebar-wrapper')
      ) {
        //Do something click is outside specified element
        document.querySelector('.page-header').className = 'page-header close_icon';
        document.querySelector('.sidebar-wrapper').className = 'sidebar-wrapper close_icon ';
      }
    });
  }, []);

  const responsive_openCloseSidebar = (toggle) => {
    if (width <= 991) {
      document.querySelector('.page-header').className = 'page-header';
      document.querySelector('.sidebar-wrapper').className = 'sidebar-wrapper ';
    } else {
      if (toggle) {
        setSidebartoggle(!toggle);
        document.querySelector('.page-header').className = 'page-header close_icon';
        document.querySelector('.sidebar-wrapper').className = 'sidebar-wrapper close_icon ';
        document.querySelector('.mega-menu-container').classList.remove('d-block');
      } else {
        setSidebartoggle(!toggle);
        document.querySelector('.page-header').className = 'page-header';
        document.querySelector('.sidebar-wrapper').className = 'sidebar-wrapper ';
      }
    }
  };

  return (
    <Fragment>
      <div className='header-logo-wrapper' id='out_side_click'>
        <div
          className='toggle-sidebar'
          onClick={() => responsive_openCloseSidebar(sidebartoggle)}
          style={window.innerWidth <= 991 ? { display: 'block' } : { display: 'none' }}
        >
          <Sliders className='status_toggle middle sidebar-toggle' id='sidebar-toggle' />
        </div>
      </div>
      <Col className='left-header horizontal-wrapper pl-0'>
        <ul style={{ display: 'flex' }} className='horizontal-menu'>
          <li className='mega-menu outside'>
            <a className={`nav-link`} id='claimEternal' onClick={() => claim()} href='#'>
              <span>CLAIM {parseFloat(claimRewards).toFixed(3)} $ETERNAL</span>
            </a>
            <Tooltip placement='bottom' isOpen={basictooltip} target='claimEternal' toggle={toggle}>
              You will be penalized with <b>{claimTax}% ETERNAL</b> (Tax is reduced 2% per day) for early claim.
            </Tooltip>
          </li>
          <li>
            <VideoAnimationToggle />
          </li>
        </ul>
      </Col>
    </Fragment>
  );
};

export default Leftbar;
